<app-header></app-header>

<div class="my-discounts container">
  <div class="my-discounts__heading">
    <div>
      <h1>{{ 'marketplace.discounts.title' | transloco }}</h1>
      <p class="my-discounts__subtitle">
        {{ 'marketplace.discounts.subtitle' | transloco }}
      </p>
    </div>
  </div>

  <app-account-tabs class="my-discounts__tabs"></app-account-tabs>

  <app-helper-banner>
    <div helper-content>
      {{ 'marketplace.discounts.helper'|transloco }}
    </div>
  </app-helper-banner>

  <div class="gift-card-list">
    @if (!giftCards) {
      @for (placeholder of placeholders; track placeholder) {
        <div class="gift-card-card gift-card-card--loading">
          <div class="gift-card-card__header">
            <div class="gift-card-card__loading-line skeleton-loading"></div>
            <div class="gift-card-card__loading-tag skeleton-loading"></div>
          </div>
          <div class="gift-card-card__body">
            <div class="gift-card-card__loading-amount skeleton-loading"></div>
            <div class="gift-card-card__loading-meta">
              <div class="gift-card-card__loading-line skeleton-loading"></div>
              <div class="gift-card-card__loading-line skeleton-loading"></div>
            </div>
          </div>
        </div>
      }
    }

    @if (giftCards?.length) {
      @for (card of giftCards; track card.id) {
        <div class="gift-card-card">
          <div class="gift-card-card__header">
            <div class="gift-card-card__code-block">
              <p class="gift-card-card__label">
                {{ 'marketplace.discounts.list.code' | transloco }}
              </p>
              <div class="gift-card-card__code-row">
                <p class="gift-card-card__code">
                  {{ card.code }}
                </p>
                <button
                  class="gift-card-card__copy-button"
                  type="button"
                  (click)="copyCode(card.code)"
                  [attr.aria-label]="'marketplace.discounts.list.copy' | transloco"
                >
                  <i class="fa-solid fa-copy"></i>
                  <span>{{ 'marketplace.discounts.list.copy' | transloco }}</span>
                </button>
              </div>
            </div>
            <div class="gift-card-card__status">
              <span class="tag" [ngClass]="getStatusTagClass(card.status)">
                <i class="fa-solid fa-badge-percent"></i>
                <span>{{ ('marketplace.discounts.status.' + card.status) | transloco }}</span>
              </span>
            </div>
          </div>

          <div class="gift-card-card__body">
            <div class="gift-card-card__amount">
              <p class="gift-card-card__label">
                {{ 'marketplace.discounts.list.remaining' | transloco }}
              </p>
              <p class="gift-card-card__amount-value">
                {{ card.remainingAmount | currency:'EUR' }}
              </p>
              <p class="gift-card-card__meta-hint">
                {{ 'marketplace.discounts.list.initial' | transloco }}
                · {{ card.initialAmount | currency:'EUR' }}
              </p>
            </div>
            <div class="gift-card-card__meta">
              <div>
                <p class="gift-card-card__label">
                  {{ 'marketplace.discounts.list.expires' | transloco }}
                </p>
                <p class="gift-card-card__meta-value">
                  @if (card.expiresAt) {
                    {{ card.expiresAt.toJSDate() | date: 'd MMMM y' }}
                  } @else {
                    {{ 'marketplace.discounts.list.no-expiration' | transloco }}
                  }
                </p>
              </div>
              <div>
                <p class="gift-card-card__label">
                  {{ 'marketplace.discounts.list.updated' | transloco }}
                </p>
                <p class="gift-card-card__meta-value">
                  @if (card.lastRedeemedAt) {
                    {{ card.lastRedeemedAt.toJSDate() | date: 'd MMMM y' }}
                  } @else {
                    {{ 'marketplace.discounts.list.never-used' | transloco }}
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    }

    @if (giftCards && giftCards.length === 0) {
      <div class="empty-state">
        <i class="empty-state__icon fa-solid fa-gift"></i>
        <h3>{{ 'marketplace.discounts.empty.title'|transloco }}</h3>
        <p>{{ 'marketplace.discounts.empty.description'|transloco }}</p>
        <a class="button"
           [routerLink]="['/']"
        >
          {{ 'marketplace.discounts.empty.cta'|transloco }}
          <i class="fa-solid fa-arrow-right"></i>
        </a>
      </div>
    }
  </div>
</div>
